export default "__VITE_ASSET__b4f47da9__"